import React from 'react'
import {  withRouter, Link } from "react-router-dom"
class SVTopNavitem extends  React.Component{

    constructor(props){
        super(props)
        

    }

    render(){
        let svIsActive = false
       
        console.log('sv******SVTopNavitem props start')
        console.log(this.props)
        //const {index, to, children, ...props} = this.props
        const {pufancy, svselected} = this.props
        const {history, location, to} = this.props

        const {index, children, ...props} = this.props
        let myname = to
       
        console.log(myname)
        const {pathname} = location
        console.log(pathname)
       
        if (pathname == myname){
            console.log('sv******SVTopNavitem svIsActive true')
            svIsActive = true
        }else{
            console.log('sv******SVTopNavitem svIsActive false')
            svIsActive = false
        }
        console.log('sv******SVTopNavitem props end', pathname)
        let showfancy = false
        let f = {
            pufancy :false,
            puto : '/bus'
        }
        if(pathname === '/tacos'){
            f['pufancy'] = true
            f['pauto'] = '/tacos'
            showfancy = pufancy['pufancy']
            console.log('sv****showfancy')
            

        }
      
        
        const SVLink = Link
        return(

            <li className={svselected? "active":""}>
             <SVLink to={to} {...props} > {children}</SVLink>
            </li>

           


        )
    }

}

SVTopNavitem = withRouter(SVTopNavitem)
export default SVTopNavitem